import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-lock-user-dialog',
  templateUrl: './lock-user-dialog.component.html',
  styleUrls: ['./lock-user-dialog.component.scss']
})
export class LockUserDialogComponent {

  public actionPerformed: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<LockUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  toggleMessage(){
    this.actionPerformed = true;
  }

  toggleLock(memberId: number): void {
    this.userService.toggleLock(memberId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (result: string) => {
          this.userService.getMembers().pipe(takeUntil(this.destroy$)).subscribe();
          this.actionPerformed = true;
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
